import { call } from 'redux-saga/effects';
import { SEARCH_PATH } from 'features/Search/Search.route.path';
import { deepExtract } from 'helpers/deep';

export function* venuesOnEnterSaga(nextState, replaceState) {
  const hash = deepExtract('params.hashDescriptor', nextState);
  if (typeof hash === 'string') {
    yield call(replaceState, {
      pathname: `${SEARCH_PATH}/${hash}`,
      state: { status: 301 },
    });
  }
}
